interface IFormatCurrencyOptions {
  cents?: boolean
}

export function formatCurrency(amount: number, options: IFormatCurrencyOptions = {}) {
  const dollars = Math.floor(amount / 100)
  const cents = amount % 100

  const parts = ['$', dollars]
  if (options.cents) {
    const formattedCents = formatCents(cents)
    parts.push('.', formattedCents)
  }

  return parts.join('')
}

function formatCents(cents: number) {
  return cents < 10 ? `0${cents}` : `${cents}`
}

interface IFormatCurrencyRangeOptions extends IFormatCurrencyOptions {
  separator?: string
}

export function formatCurrencyRange(
  minAmount: number,
  maxAmount: number,
  options: IFormatCurrencyRangeOptions = {},
) {
  if (minAmount === maxAmount) return formatCurrency(minAmount, options)

  const { separator = '-' } = options
  return `${formatCurrency(minAmount, options)} ${separator} ${formatCurrency(maxAmount, options)}`
}
